export const isInterface = <T>(value: unknown, keys: (keyof T)[], requiredKeys: (keyof T)[]): value is T => {
    if (typeof value !== "object" || value === null)
        return false;

    return(
        requiredKeys.every(key => key in value) &&                              //  Ensure all required keys are present
        (Object.keys(value) as (keyof T)[]).every(key => keys.includes(key))    //  Ensure no undefined keys are present
    );
};

export function isKeyOf<T extends object, K extends PropertyKey>(
    obj: T,
    key: K
): key is K & keyof T {
    return key in obj;
}

export function toPropertyKey<T extends object, K extends PropertyKey>(
    obj: T,
    key: K,
    fallback: keyof T
): keyof T {
    return isKeyOf(obj, key) ? key : fallback;
}

export function getValueByKey<T extends object>(
    obj: T,
    key: string,
    fallback: T[keyof T]
): T[keyof T] {
    return isKeyOf(obj, key) ? obj[key] : fallback;
}